var exports = {
  "no": "OkeyBoard.module__board___eTlVeG",
  "Nu": "OkeyBoard.module__opponents___eTlVeG",
  "am": "OkeyBoard.module__seat___eTlVeG",
  "Gn": "OkeyBoard.module__seatHead___eTlVeG",
  "yU": "OkeyBoard.module__seatBody___eTlVeG",
  "Fd": "OkeyBoard.module__seatName___eTlVeG",
  "U9": "OkeyBoard.module__count___eTlVeG",
  "nl": "OkeyBoard.module__deadline___eTlVeG",
  "hN": "OkeyBoard.module__ring___eTlVeG",
  "YQ": "OkeyBoard.module__ringTrack___eTlVeG",
  "YA": "OkeyBoard.module__ringFill___eTlVeG",
  "Ij": "OkeyBoard.module__seconds___eTlVeG",
  "gX": "OkeyBoard.module__center___eTlVeG",
  "q3": "OkeyBoard.module__indicator___eTlVeG",
  "W5": "OkeyBoard.module__centerLabel___eTlVeG",
  "Bc": "OkeyBoard.module__pile___eTlVeG",
  "o1": "OkeyBoard.module__actions___eTlVeG",
  "Zc": "OkeyBoard.module__withTile___eTlVeG",
  "aK": "OkeyBoard.module__hint___eTlVeG",
  "z3": "OkeyBoard.module__error___eTlVeG",
};

module.exports = exports;
